import SkeletonInscriptionCenter from "./SkeletonInscriptionCenter";

export default SkeletonInscriptionCenter;
